import { render, staticRenderFns } from "./recaptcha.vue?vue&type=template&id=6648adba&"
import script from "./recaptcha.vue?vue&type=script&lang=js&"
export * from "./recaptcha.vue?vue&type=script&lang=js&"
import style0 from "./recaptcha.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports